export default __webpack_public_path__ + "static/media/sounds/rct_accuracy_direction.mp3";